import { render, staticRenderFns } from "./pre_radio.vue?vue&type=template&id=2e8425e7"
import script from "./pre_radio.vue?vue&type=script&lang=js"
export * from "./pre_radio.vue?vue&type=script&lang=js"
import style0 from "./pre_radio.vue?vue&type=style&index=0&id=2e8425e7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports